import { Box, Button, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  rows: any[]; // 🔥 IMPORTANTE: Ahora recibes rows
}

const getColumnsVerificacionPE = ({
  handleVerClick,
  urlOrigen,
   rows
}: ColumnsProps): GridColDef[] => {
  const formatNumber = (value: any) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  const columns: GridColDef[] = [
    {
      field: "municipio",
      headerName: "Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.municipio}</p>;
      },
    },
    {
      field: "ISN",
      headerName: "Impuesto Sobre Nóminas",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.ISN)}</p>;
      },
    },
    {
      field: "ICV",
      headerName: "Derechos de Control Vehicular",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.ICV)}</p>;
      },
    },
    {
      field: "TEN_EST",
      headerName: "Tenencia Estatal",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.TEN_EST)}</p>;
      },
    },
    {
      field: "TEN_FED",
      headerName: "Tenencia Federal",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.TEN_FED)}</p>;
      },
    },
    {
      field: "DER_ALC",
      headerName: "Derecho alcoholes",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.DER_ALC)}</p>;
      },
    },
    {
      field: "total_monto",
      headerName: "TOTALES",
      width: 250,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },


  ];

  const filteredColumns = columns.filter(col =>
    rows.some(row => row[col.field] !== undefined && row[col.field] !== null)
  );

  return filteredColumns;
};

export default getColumnsVerificacionPE;
